<p-panel header="Seleccione una compañía haciendo doble click">
  @if (loaded) {
    <div >
      <p-table
        #table
        [value]="lsData"
        [paginator]="true"
        [rows]="3"
        [totalRecords]="totalRows"
        styleClass="font-size: 12px; p-datatable-sm;"
        [showCurrentPageReport]="true"
        scrollDirection="both"
        [sortField]="'razon_social'"
        [sortOrder]="1"
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros" >
        <ng-template pTemplate="header" let-columns>
          <tr class="header-table">
            <th scope="col" pSortableColumn="ruc">
              <div style="text-align: center;">
                Ruc<p-sortIcon field="ruc"></p-sortIcon>
              </div>
            </th>
            <th scope="col" pSortableColumn="razon_social">
              <div style="text-align: center;">
                Razón Social<p-sortIcon field="razon_social"></p-sortIcon>
              </div>
            </th>
          </tr>
          <tr>
            <th scope="col" [hidden]="true">
            </th>
            <th scope="col">
              <p-columnfilter type="text" field="ruc"
                        matchMode="contains"
                        [showMenu]="false" (paste)="onKeyDownLettersAndNumbers($event)" (keypress)="onKeyDownLettersAndNumbers($event)"></p-columnfilter>
            </th>
            <th scope="col">
              <p-columnfilter type="text" field="razon_social"
                        matchMode="contains"
                        [showMenu]="false" (paste)="onKeyDownLettersAndNumbers($event)" (keypress)="onKeyDownLettersAndNumbers($event)"></p-columnfilter>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data let-rowIndex="rowIndex">
          <tr style="cursor: pointer;" [pSelectableRow]="data" (dblclick)="onRowDblClick($event, data)">
            <td [hidden] = "true">
              {{data.Id}}
            </td>
            <td class="center">
              {{data.ruc}}
            </td>
            <td>
              {{data.razon_social}}
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="3">No existen registros.</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  } @else {
    <app-table-skeleton [columns]="2" [rows]="3"/>
  }


</p-panel>

